import { Component } from '@angular/core';

@Component({
    selector: 'tt-ai-chat-thinking',
    templateUrl: './ai-chat-thinking.component.html',
    styleUrls: ['./ai-chat-thinking.component.css'],
    standalone: false,
})
export class AiChatThinkingComponent {
}
